// extracted by mini-css-extract-plugin
module.exports = {"card-row":"MarketingSummaryKPIs_card-row__z9zyN","kpi-icon":"MarketingSummaryKPIs_kpi-icon__AbGD6"};